import * as React from 'react'
import {connect} from "react-redux"
import {combineReducers, Reducer, Store} from "redux";

import {HorizontalRule} from "../../lib/sbhtml/horizontal-rule"
import {InfoformField, PricingOptionState} from "./common/types"
import {StandardItemsContainer} from "./standard-items/container";
import {SignupFieldItemsContainer, RenewFieldItemsContainer, StoreProps} from "./field-items/container";
import {items} from "./standard-items/reducer";
import {fieldCostItems} from "./field-items/reducer";

const noOpReducer = function<T>(defaultState:T) {
	return (state:T = defaultState, action: any): T => state
}

export const pricesApp:Reducer<PricingOptionState> = combineReducers<PricingOptionState>({
	standardCostItems: combineReducers({
		items,
		signupFields: noOpReducer([] as InfoformField[]),
		renewFields:  noOpReducer([] as InfoformField[]),
		autoRenewalEnabled: noOpReducer(false)
	}),
	signupFieldCostItems: fieldCostItems,
	renewFieldCostItems:  fieldCostItems,
})

const FormContainer = (props: StoreProps) =>
	<div>
		<HorizontalRule />
		<StandardItemsContainer labels={props.labels} store={props.store} />
		<HorizontalRule />
		<div>
			<div style={{float: "left", minWidth: "300px", maxWidth: "500px"}}><SignupFieldItemsContainer labels={props.labels} store={props.store} /></div>
			<div style={{float: "left", minWidth: "300px", maxWidth: "500px", marginLeft: "2em"}}><RenewFieldItemsContainer labels={props.labels} store={props.store} /></div>
		</div>
		<div style={{clear: "both"}}></div>
		<HorizontalRule/>
	</div>

const secondId = <A extends {}>(a: A, b: StoreProps) => b

export const Form = connect<StoreProps, StoreProps, StoreProps>(secondId, secondId)(FormContainer)



// WEBPACK FOOTER //
// ./src/membership3/pricing-option-form/app.tsx